import React from 'react';

/**
 * LoadingSpinner - Reusable loading indicator
 * Replaces "Loading..." text with proper spinner
 */
const LoadingSpinner = ({ size = 'md', text = '', className = '' }) => {
  const sizeClasses = {
    sm: 'h-4 w-4 border-2',
    md: 'h-8 w-8 border-3',
    lg: 'h-12 w-12 border-4',
    xl: 'h-16 w-16 border-4',
  };

  return (
    <div className={`flex flex-col items-center justify-center gap-3 ${className}`}>
      <div
        className={`${sizeClasses[size]} border-boop-primary border-t-transparent rounded-full animate-spin`}
        role="status"
        aria-label="Loading"
      />
      {text && (
        <p className="text-sm text-gray-600 dark:text-spooky-ghost-white animate-pulse">
          {text}
        </p>
      )}
    </div>
  );
};

export default LoadingSpinner;
